import { NbAuthToken } from './token/token';

export class NbRefreshToken
{
  // constructor(exp:any, token:any, userId:any)
  // {
  //   this.expiryDate = exp;
  //   this.token = token;
  //   this.userId = userId;
  // }
  expiryDate: string
  token: string;
  userId: string;
}
export class NbAuthResult {

  protected token: NbAuthToken;
  protected refreshToken: NbRefreshToken;
  protected errors: string[] = [];
  protected messages: string[] = [];

  // TODO: better pass object
  constructor(protected success: boolean,
              protected response?: any,
              protected redirect?: any,
              errors?: any,
              messages?: any,
              token: NbAuthToken = null,
              refreshToken: NbRefreshToken = null) {
    this.errors = this.errors.concat([errors]);
    if (errors instanceof Array) {
      this.errors = errors;
    }

    this.messages = this.messages.concat([messages]);
    if (messages instanceof Array) {
      this.messages = messages;
    }

    this.token = token;

    this.refreshToken = refreshToken;
  }

  getResponse(): any {
    return this.response;
  }

  getToken(): NbAuthToken {
    return this.token;
  }
  getRefreshToken(): NbRefreshToken {
    return this.refreshToken;
  }
  getRedirect(): string {
    return this.redirect;
  }

  getErrors(): string[] {
    return this.errors.filter(val => !!val);
  }

  getMessages(): string[] {
    return this.messages.filter(val => !!val);
  }

  isSuccess(): boolean {
    return this.success;
  }

  isFailure(): boolean {
    return !this.success;
  }
}
